// app/router.options.ts
import type { RouterConfig } from "@nuxt/schema";
import type { RouteRecordRaw } from "vue-router";

export default {
  routes: (): RouteRecordRaw[] => [
    // 首页
    {
      name: "home",
      path: "/",
      component: () => import("@/views/Home/index.vue"),
      meta: {
        fullWidth: true,
        hasAppFooterTopMargin: false,
        footerTheme: "dark",
      },
    },
    // 分类页面
    {
      name: "category",
      path: "/category",
      component: () => import("@/views/Category/index.vue"),
    },
    // 商品详情页面
    {
      name: "productDetail",
      path: "/product/:spu",
      component: () => import("@/views/ProductDetail/index.vue"),
      meta: { hideFooter: true },
    },
    // 结算页面
    {
      name: "checkout",
      path: "/checkout",
      component: () => import("@/views/Checkout/index.vue"),
    },
    // 销售报价确认与结算
    {
      name: "salesQuote",
      path: "/sales-quote",
      component: () => import("@/views/SalesQuote/index.vue"),
    },
    {
      name: "salesQuoteCheckout",
      path: "/sales-quote/checkout",
      component: () => import("@/views/SalesQuote/Checkout.vue"),
    },
    {
      name: "salesQuotePaymentConfirm",
      path: "/sales-quote/payment/confirm",
      component: () => import("@/views/SalesQuote/PaymentConfirm.vue"),
      meta: { requiresAuth: true },
    },
    // 订单
    {
      name: "orders",
      path: "/orders",
      component: () => import("@/views/Orders/index.vue"),
    },
    // 货源商城
    {
      name: "supplyMall",
      path: "/supply-mall",
      component: () => import("@/views/SupplyMall/index.vue"),
    },
    {
      name: "s2bdiyProductDetail",
      path: "/global-product/:id",
      component: () => import("@/views/S2BDiyProductDetail/index.vue"),
      meta: { hideFooter: true },
    },
    {
      name: "s2bdiyCheckout",
      path: "/s2bdiy/checkout",
      component: () => import("@/views/S2BDiyCheckout/index.vue"),
      meta: { hideFooter: true },
    },
    // 在线3D打印
    {
      name: "print3d",
      path: "/print3d",
      component: () => import("@/views/Print3D/index.vue"),
    },
    // 3D模型预览
    {
      name: "print3dPreview",
      path: "/print3d/preview",
      component: () => import("@/views/Print3DPreview/index.vue"),
      meta: { layout: "blank" },
    },
    // 3D 模型自动减面
    {
      name: "print3dModelReduction",
      path: "/print3d/model-reduction",
      component: () => import("@/views/Print3D/ModelReduction.vue"),
    },
    // 搜索结果
    {
      name: "search",
      path: "/search",
      component: () => import("@/views/Search/index.vue"),
    },
    // AI 工具中心
    {
      name: "aiTools",
      path: "/ai-tools",
      component: () => import("@/views/AITools/index.vue"),
    },
    // AI 工具子页面
    {
      name: "aiToolShortVideo",
      path: "/ai-tools/short-video",
      component: () => import("@/views/AITools/ShortVideoReplicate.vue"),
    },
    {
      name: "aiToolDetailPage",
      path: "/ai-tools/detail-page",
      component: () => import("@/views/AITools/DetailPageGenerate.vue"),
    },
    {
      name: "aiToolProductSet",
      path: "/ai-tools/product-set",
      component: () => import("@/views/AITools/ProductSetImages.vue"),
    },
    {
      name: "aiToolProductImageReplica",
      path: "/ai-tools/product-image-replica",
      component: () => import("@/views/AITools/ProductImageReplica.vue"),
    },
    {
      name: "aiToolModelOOTD",
      path: "/ai-tools/model-ootd",
      component: () => import("@/views/AITools/ModelOOTD.vue"),
    },
    {
      name: "aiToolEcommerceCollage",
      path: "/ai-tools/ecommerce-collage",
      component: () => import("@/views/AITools/EcommerceProductCollage.vue"),
    },
    {
      name: "aiToolEcommerceModelVideo",
      path: "/ai-tools/ecommerce-model-video",
      component: () => import("@/views/AITools/EcommerceModelToVideo.vue"),
    },
    {
      name: "aiToolDouyinVideo",
      path: "/ai-tools/douyin-video",
      component: () => import("@/views/AITools/DouyinVideoToScript.vue"),
    },
    {
      name: "aiToolBackgroundRemove",
      path: "/ai-tools/background-remove",
      component: () => import("@/views/AITools/ImageBackgroundRemove.vue"),
    },
    {
      name: "aiToolVideoDownload",
      path: "/ai-tools/video-download",
      component: () => import("@/views/AITools/MultiPlatformVideoDownload.vue"),
    },
    // AI 商品列表
    {
      name: "aiProducts",
      path: "/ai-product",
      component: () => import("@/views/AIProducts/index.vue"),
    },
    // AI 商品详情
    {
      name: "aiProductDetail",
      path: "/ai-product/:spu",
      component: () => import("@/views/ProductDetail/index.vue"),
    },
    {
      name: "worldCupFridgeMagnetCustom",
      path: "/ai-custom/world-cup-fridge-magnet/:spu",
      component: () =>
        import("@/views/AIProducts/WorldCupFridgeMagnet/index.vue"),
    },
    {
      name: "moonFridgeMagnetCustom",
      path: "/ai-custom/moon-fridge-magnet/:spu",
      component: () => import("@/views/AIProducts/MoonFridgeMagnet/index.vue"),
    },
    // AI 定制设计器
    {
      name: "aiCustomProduct",
      path: "/ai-custom/:spu",
      component: () => import("@/views/AIProducts/Custom/index.vue"),
    },
    // 我的商品（保存的定制商品）
    {
      name: "savedProducts",
      path: "/ai-custom/saved-products",
      component: () => import("@/views/AIProducts/SavedProducts/index.vue"),
    },
    // 任务中心
    {
      name: "taskCenter",
      path: "/task-center",
      component: () => import("@/views/TaskCenter/index.vue"),
    },
    // 个人信息
    {
      name: "profile",
      path: "/profile",
      component: () => import("@/views/Profile/index.vue"),
    },
    // 我的收藏（v1.3.1，当前为本地收藏；接口就绪后可接后端）
    {
      name: "favorites",
      path: "/favorites",
      component: () => import("@/views/Favorites/index.vue"),
    },
    // ODM 定制
    {
      name: "odm",
      path: "/odm",
      component: () => import("@/views/ODM/index.vue"),
    },
    // 算力充值
    {
      name: "computeRecharge",
      path: "/compute/recharge",
      component: () => import("@/views/Compute/Recharge.vue"),
    },
    // 算力消费记录
    {
      name: "computeRecords",
      path: "/compute/records",
      component: () => import("@/views/Compute/Records.vue"),
    },
    // 获得免费算力
    {
      name: "freeComputeRedeem",
      path: "/compute/free-redeem",
      component: () => import("@/views/Compute/FreeComputeRedeem.vue"),
    },
    // 视频复刻工具（独立页面，空白 layout）
    {
      name: "videoReplication",
      path: "/ai-tools/video-replication",
      component: () =>
        import("@/views/StandaloneTools/VideoReplication/index.vue"),
      meta: { layout: "blank" },
    },
    // 微信登录回调
    {
      name: "wechatCallback",
      path: "/wechatcallback",
      component: () => import("@/views/WechatCallback/index.vue"),
    },
    // H5 页面（独立页面，空白 layout）
    {
      name: "h5Page",
      path: "/h5",
      component: () => import("@/views/H5Page/index.vue"),
      meta: { layout: "blank" },
    },
    // H5登录之后的页面
    {
      name: "h5Success",
      path: "/h5/success",
      component: () => import("@/views/H5Page/Success.vue"),
      meta: { layout: "blank" },
    },
    {
      name: "h5SupplyMall",
      path: "/h5/supply-mall",
      component: () => import("@/views/H5/SupplyMall/index.vue"),
      meta: { layout: "h5" },
    },
    {
      name: "h5SalesQuote",
      path: "/h5/sales-quote",
      component: () => import("@/views/SalesQuote/index.vue"),
      meta: { layout: "h5", hideFooter: true },
    },
    {
      name: "h5SalesQuoteCheckout",
      path: "/h5/sales-quote/checkout",
      component: () => import("@/views/H5/SalesQuote/Checkout.vue"),
      meta: { layout: "h5", hideFooter: true, requiresAuth: true },
    },
    {
      name: "h5ProductDetail",
      path: "/h5/product/:spu",
      component: () => import("@/views/H5/ProductDetail/index.vue"),
      meta: { layout: "h5", hideFooter: true },
    },
    {
      name: "h5Cart",
      path: "/h5/cart",
      component: () => import("@/views/H5/Cart/index.vue"),
      meta: { layout: "h5", requiresAuth: true },
    },
    {
      name: "h5Checkout",
      path: "/h5/checkout",
      component: () => import("@/views/H5/Checkout/index.vue"),
      meta: { layout: "h5", requiresAuth: true },
    },
    {
      name: "h5Address",
      path: "/h5/address",
      component: () => import("@/views/H5/Address/index.vue"),
      meta: { layout: "h5", requiresAuth: true },
    },
    {
      name: "h5AddressEdit",
      path: "/h5/address/edit",
      component: () => import("@/views/H5/Address/Edit.vue"),
      meta: { layout: "h5", requiresAuth: true },
    },
    {
      name: "h5PaymentStatus",
      path: "/h5/payment/status",
      component: () => import("@/views/H5/Payment/Status.vue"),
      meta: { layout: "h5", requiresAuth: true },
    },
    {
      name: "h5PaymentConfirm",
      path: "/h5/payment/confirm",
      component: () => import("@/views/H5/Payment/Confirm.vue"),
      meta: { layout: "h5", requiresAuth: true },
    },
    {
      name: "h5Orders",
      path: "/h5/orders",
      component: () => import("@/views/H5/Orders/index.vue"),
      meta: { layout: "h5", requiresAuth: true },
    },
    {
      name: "h5DesktopOnly",
      path: "/h5/desktop-only",
      component: () => import("@/views/H5/DesktopOnly/index.vue"),
      meta: { layout: "h5" },
    },
  ],
} satisfies RouterConfig;
